export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image4-c6c6ed01fccfce853e543d9a58a24076.png";